export const TestIntroSelectors = {
	testIntro: 'test-intro',
	cancel: 'cancel-button',
	startTest: 'start-test-button',
};
